import { __awaiter, __generator } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { OfficeDotComOrigin } from '@office-start/officehome-types';
export function fetchMiddleTierSearchConfiguration(_a) {
    var searchInstrumenter = _a.searchInstrumenter, searchPrefetch = _a.searchPrefetch, tokenProviders = _a.tokenProviders, searchMiddleTierEnvironment = _a.searchMiddleTierEnvironment, searchConfig = _a.searchConfig, sharePointResourceId = _a.sharePointResourceId, searchCenterUrl = _a.searchCenterUrl;
    return __awaiter(this, void 0, void 0, function () {
        var options, query;
        var _this = this;
        return __generator(this, function (_b) {
            options = {
                clientType: OfficeDotComOrigin,
                environment: searchMiddleTierEnvironment,
                tokenProvider: tokenProviders.lokiTokenProvider,
                thorTokenProvider: tokenProviders.thorTokenProvider,
                useThor: searchConfig.useThorEnabled,
                useSimpleRequest: searchConfig.useSimpleRequest,
                additionalHeaders: {
                    'X-MSSearchComponent': 'SERP',
                },
                warmupCallOptions: {
                    userContextUrl: searchCenterUrl === '/search'
                        ? "".concat(sharePointResourceId, "/search")
                        : searchCenterUrl || '',
                    scenario: 'officehome',
                },
            };
            query = ['SearchConfigurationQuery'];
            return [2 /*return*/, queryCache.fetchQuery(query, function () { return __awaiter(_this, void 0, void 0, function () {
                    var searchConfig;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                searchInstrumenter.mark('SerpConfigStart');
                                return [4 /*yield*/, searchPrefetch.fetchAndParseSearchConfiguration(options)];
                            case 1:
                                searchConfig = _a.sent();
                                searchInstrumenter.mark('SerpConfigDone');
                                return [2 /*return*/, Promise.resolve(searchConfig)];
                        }
                    });
                }); }, {
                    cacheTime: Infinity,
                    staleTime: Infinity,
                })];
        });
    });
}
//# sourceMappingURL=fetchMiddleTierSearchConfiguration.js.map